<template>
  <div style="height: 100%">
    <el-table
      :data="tableData"
      height="100%"
      :border="true"
      :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
    >
      <el-table-column
        type="index"
        width="80"
        align="center"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="jump_time"
        align="center"
        min-width="100"
        label="结转日期"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="business_name"
        align="center"
        min-width="120"
        label="集配中心"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="tdc_name" align="center" label="城市仓">
      </el-table-column>
      <el-table-column prop="tdc_id" align="center" label="城市仓Id">
      </el-table-column>
      <el-table-column
        prop="bank_username"
        align="center"
        label="城市仓持卡人"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="amount"
        align="center"
        label="推广奖励结转金额"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="handleDetail(scope.row)">
              查看详情
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "TableList",
  props: ["tableData"],
  data() {
    return {};
  },
  mounted() {},
  watch: {},
  methods: {
    // 查看详情
    handleDetail(row) {
      this.$router.push({
        path: `/reward-settlement-detail`,
        query: {
          jump_time: row.jump_time,
          tdc_id: row.tdc_id,
          tdc_name: row.tdc_name,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
